import getOptions from 'eslint-loader/dist/getOptions';

class EnvFn {
  getOs(val) {
    let msg = '';
    switch (val) {
      case '1':
        msg = 'Win7';
        break;
      case '2':
        msg = 'Win10';
        break;
      case '3':
        msg = 'Win11';
        break;
      default:
        break;
    }
    return msg;
  }
}
export default new EnvFn();
